module.exports = __webpack_public_path__ + "static/media/ivan_mit_asst_coach.017993c3.png";